// src/components/TestimonialSection.jsx

// ----------------------------------------------------------------------
// 1. IMPORTACIONES
// ----------------------------------------------------------------------
import React from 'react';
// Importamos el componente Slider de la librería react-slick
import Slider from 'react-slick';

// ----------------------------------------------------------------------
// 2. COMPONENTE
// ----------------------------------------------------------------------
function TestimonialSection() {
  // Configuración para el carrusel de react-slick
  // Puedes ajustar estos valores para cambiar el comportamiento
  const settings = {
    dots: false,              // No mostrar los puntitos de navegación
    infinite: true,           // El carrusel es infinito
    speed: 500,               // Velocidad de la transición en milisegundos
    slidesToShow: 1,          // Cuántos slides se muestran a la vez
    slidesToScroll: 1,        // Cuántos slides avanzan con cada clic
    autoplay: true,           // Reproducción automática
    autoplaySpeed: 5000,      // Tiempo entre cada slide en milisegundos (5 segundos)
    fade: true,               // Transición de desvanecimiento (fade)
    cssEase: 'linear'         // Tipo de easing para la animación
  };

  return (
    <div className="container-xxl py-5">
      <div className="container">
        {/* Título de la sección */}
        <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: '500px'}}>
          <h1 className="display-6 mb-5">What They Say About Our Services</h1>
        </div>

        <div className="row g-5">
          {/* Columna izquierda: Imágenes decorativas (solo visibles en pantallas grandes) */}
          <div className="col-lg-3 d-none d-lg-block">
            <div className="testimonial-left h-100">
              <img className="img-fluid animated pulse infinite" src="/img/testimonial-1.jpg" alt="" />
              <img className="img-fluid animated pulse infinite" src="/img/testimonial-2.jpg" alt="" />
              <img className="img-fluid animated pulse infinite" src="/img/testimonial-3.jpg" alt="" />
            </div>
          </div>

          {/* Columna central: El carrusel de testimonios */}
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
            {/* El componente <Slider> de react-slick envuelve nuestros testimonios */}
            <Slider {...settings}>
              {/* Cada <div> es un "slide" individual */}
              <div className="testimonial-item text-center">
                <img className="img-fluid mx-auto mb-4" src="/img/testimonial-1.jpg" alt="" />
                <p className="fs-5">Dolores sed duo clita tempor justo dolor et stet lorem kasd labore dolore lorem ipsum. At lorem lorem magna ut et, nonumy et labore et tempor diam tempor erat.</p>
                <h5>Client Name</h5>
                <span>Profession</span>
              </div>

              <div className="testimonial-item text-center">
                <img className="img-fluid mx-auto mb-4" src="/img/testimonial-2.jpg" alt="" />
                <p className="fs-5">Dolores sed duo clita tempor justo dolor et stet lorem kasd labore dolore lorem ipsum. At lorem lorem magna ut et, nonumy et labore et tempor diam tempor erat.</p>
                <h5>Client Name</h5>
                <span>Profession</span>
              </div>

              <div className="testimonial-item text-center">
                <img className="img-fluid mx-auto mb-4" src="/img/testimonial-3.jpg" alt="" />
                <p className="fs-5">Dolores sed duo clita tempor justo dolor et stet lorem kasd labore dolore lorem ipsum. At lorem lorem magna ut et, nonumy et labore et tempor diam tempor erat.</p>
                <h5>Client Name</h5>
                <span>Profession</span>
              </div>
            </Slider>
          </div>

          {/* Columna derecha: Más imágenes decorativas (solo visibles en pantallas grandes) */}
          <div className="col-lg-3 d-none d-lg-block">
            <div className="testimonial-right h-100">
              <img className="img-fluid animated pulse infinite" src="/img/testimonial-1.jpg" alt="" />
              <img className="img-fluid animated pulse infinite" src="/img/testimonial-2.jpg" alt="" />
              <img className="img-fluid animated pulse infinite" src="/img/testimonial-3.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestimonialSection;